import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { useLang } from "@/lib/i18n";

const PROJECTS = [
  {
    title: "Trädgård & Mark",
    category: "Trädgård & landskapsanläggning",
    description: "Koncepthemsida för ett modernt svenskt trädgårds- och markentreprenadföretag.",
    image:
      "https://images.unsplash.com/photo-1741252453954-879d8c395d71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzY2FuZGluYXZpYW4lMjBnYXJkZW4lMjBsYW5kc2NhcGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODgzODYyNjB8MA&ixlib=rb-4.1.0&q=85",
    testid: "project-card-tradgard",
    wide: true,
  },
  {
    title: "Nordic Clean",
    category: "Städ & facility service",
    description: "Koncepthemsida och varumärke för ett svenskt städföretag.",
    image:
      "https://images.unsplash.com/photo-1609081144289-eacc3108cd03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1pbmltYWwlMjBpbnRlcmlvciUyMGRlc2lnbiUyMHdoaXRlJTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODgzODYyNjB8MA&ixlib=rb-4.1.0&q=85",
    testid: "project-card-nordic",
    wide: false,
  },
  {
    title: "Bygg & Renovering",
    category: "Bygg & totalentreprenad",
    description: "Koncepthemsida och visuell identitet för ett svenskt byggföretag.",
    image:
      "https://images.unsplash.com/photo-1556156653-e5a7c69cc263?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0aW1iZXIlMjB3b29kJTIwY29uc3RydWN0aW9uJTIwYXJjaGl0ZWN0dXJlJTIwaG91c2V8ZW58MHx8fHwxNzg4Mzg2MjYwfDA&ixlib=rb-4.1.0&q=85",
    testid: "project-card-bygg",
    wide: false,
  },
];

export default function Portfolio({ projects }) {
  const { t, dyn } = useLang();
  const list = projects?.length ? projects : PROJECTS;
  return (
    <section id="projekt" data-testid="portfolio-section" className="bg-coal py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="05" label={t("portfolio.tag")} />
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end">
          <SectionHeading>{t("portfolio.heading")}</SectionHeading>
          <Reveal delay={0.15}>
            <p className="max-w-md text-base leading-relaxed text-fog lg:ml-auto">
              {t("portfolio.sub")}
            </p>
          </Reveal>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {list.map((p, i) => (
            <Reveal key={`${p.title}-${i}`} delay={0.08 + i * 0.1} className={i === 0 ? "md:col-span-2" : ""}>
              <article
                data-testid={`project-card-${i}`}
                className={`group relative overflow-hidden rounded-2xl border border-white/10 ${
                  i === 0 ? "aspect-[16/10] md:aspect-[21/9]" : "aspect-[4/3]"
                }`}
              >
                <img
                  src={p.image}
                  alt={`${p.title} – ${p.category}`}
                  loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
                <span className="absolute left-5 top-5 rounded-full border border-white/20 bg-ink/60 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-bone backdrop-blur-md">
                  Concept Project
                </span>
                <div className="absolute inset-x-0 bottom-0 p-6 sm:p-8">
                  <p className="font-mono text-xs uppercase tracking-[0.25em] text-mint">{dyn(p.category)}</p>
                  <h3 className="mt-2 font-display text-2xl font-extrabold tracking-tight text-bone sm:text-3xl">
                    {p.title}
                  </h3>
                  <p className="mt-2 max-w-md text-sm leading-relaxed text-bone/70 opacity-0 transition-all duration-500 group-hover:opacity-100">
                    {dyn(p.description)}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
